<template>
  <div>
    <h2>Create Account</h2>

    <v-card max-width="720px" class="mt-5">
      <v-card-text>
        <v-form
          class="mt-3"
          v-model="valid"
          ref="registrationForm"
          @submit.prevent="registerAccount"
        >
          <v-row>
            <v-col cols="5">
              <v-select
                :items="titles"
                outlined
                label="Title *"
                :rules="rules.required"
                v-model="title"
              ></v-select>
            </v-col>
            <v-col cols="7">
              <v-text-field
                outlined
                label="First Name *"
                :rules="rules.required"
                v-model="firstName"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-text-field
            outlined
            label="Last Name *"
            :rules="rules.required"
            v-model="lastName"
          ></v-text-field>

          <v-combobox
            v-model="institution"
            :items="institutions"
            item-text="name"
            item-value="name"
            label="Institution name *"
            outlined
            :return-object="false"
            :rules="rules.required"
          ></v-combobox>

          <v-text-field
            outlined
            label="Department / College *"
            :rules="rules.required"
            v-model="department"
          ></v-text-field>

          <v-text-field
            outlined
            label="Specialization (optional)"
            v-model="specialization"
          ></v-text-field>

          <v-divider class="mb-7"></v-divider>

          <v-text-field
            outlined
            label="Email *"
            :rules="rules.requiredEmail"
            v-model="email"
          ></v-text-field>

          <v-text-field
            outlined
            label="Phone number (optional)"
            v-model="phone"
            hide-details
          ></v-text-field>

          <v-divider class="mb-7"></v-divider>

          <v-select
            item-disabled="disabled"
            :rules="rules.required"
            v-model="roles"
            :items="USER_ROLES"
            label="Roles *"
            outlined
            multiple
            chips
          ></v-select>

          <p class="mb-7">* mark required fields.</p>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              type="submit"
              color="green lighten-1"
              @click="registerAccount"
              :disabled="!valid"
              :loading="registering"
            >
              Register account
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { required, email } from "../../../tools/rules";
import { USER_TITLES } from "../../../tools/specs";
import Institutions from "../../../data/world_universities_and_domains-min.json";

const USER_ROLES = [
  { text: "AUTHOR", disabled: true },
  { text: "REVIEWER" },
  { text: "EDITOR" },
  { text: "PUBLISHER" },
];

// const BLANK_USER = {
//   title: null,
//   firstName: null,
//   lastName: null,
//   institution: null,
//   department: null,
//   specialization: null,
//   email: null,
//   phone: null,
//   roles: ["AUTHOR"],
// };

export default {
  data: () => ({
    title: null,
    firstName: null,
    lastName: null,
    institution: null,
    department: null,
    specialization: null,
    email: null,
    phone: null,
    roles: ["AUTHOR"],

    registering: false,

    valid: false,
    rules: {
      required,
      requiredEmail: [...required, ...email],
    },

    titles: USER_TITLES,
    institutions: Institutions,
    USER_ROLES,
  }),

  methods: {
    registerAccount() {
      if (!this.registering) {
        this.registering = true;

        const data = {
          title: this.title,
          firstName: this.firstName,
          lastName: this.lastName,
          institution: this.institution,
          department: this.department,
          specialization: this.specialization,
          email: String(this.email).trim(),
          phone: this.phone,
          roles: this.roles,
        };

        this.$axios
          .post("/users", data)
          .then(() => {
            this.$bus.$emit("snackbar", {
              type: "info",
              message: "Account has been created",
            });
            // this.$forceUpdate();
            // this.user = BLANK_USER;
            // this.$refs.registrationForm.reset();
            this.$router.push({ name: "userManagement" });
          })
          .catch(() => {
            this.$bus.$emit("snackbar", {
              type: "error",
              message:
                "Could not create account, email may already exist on system",
            });
          })
          .finally(() => {
            this.registering = false;
          });
      }
    },
  },
};
</script>